<template>
  <v-dialog max-width="90vw"
            class="px-3"
            :value="value"
            @input="toggleModal()">
    <div class="view-user-card" :class="{ 'dark': $vuetify.theme.isDark }">
      <template v-if="loadingUser">
        <v-row class="ma-0 kbGrayLightText"
               style="height: inherit">
          <v-col cols="12"
                 class="d-flex flex-column justify-center align-center align-self-stretch">
            <v-progress-circular :size="120"
                                 :width="8"
                                 color="kbWhite"
                                 indeterminate/>
            <span class="d-block kbWhite--text text-center mt-5"
                  style="font-size: 18px">
              {{ $t('general.loadingPerson') }}
            </span>
          </v-col>
        </v-row>
      </template>

      <template v-else-if="!loadingUser && !isUserSelected && value">
        <v-row class="ma-0 kbGrayLightText"
               style="height: inherit">
          <v-col cols="12"
                 style="position: relative;"
                 class="d-flex flex-column justify-center align-center align-self-stretch">
            <v-btn dark
                   icon
                   style="position: absolute; right: 10px; top: 10px"
                   @click="toggleModal()">
              <v-icon size="30px">mdi-close</v-icon>
            </v-btn>
            <v-icon :color="mainColor" size="120px">mdi-account-alert</v-icon>
            <span class="d-block kbWhite--text text-center mt-5"
                  style="font-size: 18px">
              {{ $t('general.weCouldNotFindThisPerson') }}
            </span>
          </v-col>
        </v-row>
      </template>

      <template v-else-if="value">
        <div class="d-flex justify-space-between kbWhite"
             style="height: 90vh;
                    max-height: 90vh;
                    overflow-y: hidden">
          <div class="align-self-stretch kbLight"
               style="border-right: 1px solid rgba(0, 0, 0, 0.18);
                      transition: all ease-in-out 0.3s"
               :style="{
                         flexBasis: minimizedSideMenu ? '70px' : '271px',
                         maxWidth: minimizedSideMenu ? '70px' : '271px'
                      }"
               v-if="$vuetify.breakpoint.mdAndUp">
            <SideMenu :current-component="currentComponent"
                      :minimized-side-menu="minimizedSideMenu"
                      @toggleModal="toggleModal()"
                      @toggleSideMenu="toggleSideMenu()"
                      @changeCurrentComponent="changeCurrentComponent($event)" />
          </div>

          <v-row class="ma-0 align-self-stretch"
                 style="transition: all ease-in-out 0.3s"
                 :style="dialogWidth">
            <v-col cols="12"
                   class="px-0 pt-0 mb-11"
                   :style="{ paddingBottom: $vuetify.breakpoint.smAndDown ? '100px!important' : '80px!important' }">
              <TheHeader :current-component="currentComponent"
                         :main-color="mainColor"
                         :minimized-header="minimizedHeader"
                         :minimized-side-menu="minimizedSideMenu"
                         :socialNetworksRegistered="socialNetworksRegistered"
                         :selected-country-phone="selectedCountryPhone"
                         @changeCurrentComponent="changeCurrentComponent($event)"
                         @toggleMinimizedHeader="toggleMinimizedHeader($event)"
                         @toggleModal="toggleModal()"
                         @toggleSideMenu="toggleSideMenu()"
                         @updatePerson="updatePerson($event)"/>
            </v-col>

            <v-col cols="12" class="pt-0" v-show="isDividerShown">
              <v-divider/>
            </v-col>

            <v-col cols="12" class="py-0 px-6 component-container" :class="{ 'full-height': minimizedHeader }">
              <component :is="currentComponent"
                         :socialNetworksRegistered="socialNetworksRegistered"
                         :main-color="mainColor"
                         :minimized-side-menu="minimizedSideMenu"
                         :selected-country-phone="selectedCountryPhone"
                         :user-id="userId"
                         @changeDialogLoaderStatus="changeDialogLoaderStatus($event)"
                         @getUser="getUser()"
                         @updatePerson="updatePerson($event)"/>
            </v-col>
          </v-row>
        </div>
      </template>
    </div>
  </v-dialog>
</template>

<script>
import Actions from '@/pages/App/People/dialogs/ViewUser/Actions'
import Businesses from '@/pages/App/People/dialogs/ViewUser/Businesses/Businesses'
import Calls from '@/pages/App/People/dialogs/ViewUser/Calls'
import Documents from '@/pages/App/People/dialogs/ViewUser/Documents'
import ListPicker from '@/pages/App/People/dialogs/ViewUser/ListPicker'
import Notes from '@/pages/App/People/dialogs/ViewUser/Notes'
import Preferences from '@/pages/App/People/dialogs/ViewUser/Preferences'
import Profile from '@/pages/App/People/dialogs/ViewUser/Profile/Profile'
import SendSms from '@/pages/App/People/dialogs/ViewUser/SendSms'
import SetResponsible from '@/pages/App/People/dialogs/ViewUser/SetResponsible'
import SideMenu from '@/pages/App/People/dialogs/ViewUser/SideMenu/SideMenu'
import Tasks from '@/pages/App/People/dialogs/ViewUser/Tasks/Tasks'
import TheHeader from '@/pages/App/People/dialogs/ViewUser/TheHeader/TheHeader'
import UserJourney from '@/pages/App/People/dialogs/ViewUser/UserJourney'
/* Libraries and state */
import countries from '@/libs/countries'
import { mapState } from 'vuex'
import notifications from '@/libs/notifications'
export default {
  components: {
    Actions,
    Businesses,
    Calls,
    Preferences,
    Documents,
    ListPicker,
    Notes,
    Profile,
    SendSms,
    SideMenu,
    SetResponsible,
    Tasks,
    TheHeader,
    UserJourney
  },
  computed: {
    ...mapState({
      selectedUser: state => state.users.selectedUser
    }),
    dialogWidth () {
      if (this.$vuetify.breakpoint.smAndDown) {
        return { maxWidth: '100%!important' }
      }
      return this.minimizedSideMenu
        ? { flexBasis: 'calc(90vw - 70px)', maxWidth: 'calc(90vw - 70px)' }
        : { flexBasis: 'calc(90vw - 271px)', maxWidth: 'calc(90vw - 271px)' }
    },
    isDividerShown () {
      return this.currentComponent !== 'Profile'
    },
    isUserSelected () {
      return !(!this.userId || !this.selectedUser || Object.keys(this.selectedUser).length === 0)
    },
    selectedCountryPhone () {
      let { country, phone } = this.selectedUser
      if (country === null) country = ''
      if (phone === null) phone = ''
      const selectedCountry = this.countries.find(item => item.code === country.toLowerCase())
      if (!country || !selectedCountry) {
        return {
          country: 'Colombia',
          code: 'co',
          number: '57',
          mask: '### ### #### ######',
          phone: phone || ''
        }
      }
      selectedCountry.phone = phone || ''
      return selectedCountry
    },
    socialNetworksRegistered () {
      const socialNetworksRegistered = {
        facebook: false,
        instagram: false,
        spotify: false
      }
      try {
        if (!this.auths || this.auths.length === 0) {
          return socialNetworksRegistered
        }

        const authProviders = this.auths.map(item => item.provider.name.toLowerCase())

        for (const key in socialNetworksRegistered) {
          if (authProviders.includes(key)) {
            socialNetworksRegistered[key] = true
          }
        }
        return socialNetworksRegistered
      } catch (e) {
        console.log(e)
      }
      return socialNetworksRegistered
    }
  },
  data () {
    return {
      countries,
      currentComponent: 'Profile',
      loadingUser: false,
      minimizedHeader: false,
      minimizedSideMenu: true
    }
  },
  methods: {
    changeCurrentComponent (component) {
      this.currentComponent = component
    },
    clearSelectedUser () {
      this.changeCurrentComponent('Profile')
      this.$store.commit('SET_SELECTED_USER', {})
      this.$store.commit('SET_HISTORICAL_ACTIONS', [])
      this.$emit('clearUserIdAndAuths')
      this.$emit('getUsers')
    },
    changeDialogLoaderStatus (value) {
      this.loadingUser = value
    },
    checkIfPromotorRolWasAssigned (roles) {
      if (this.selectedUser.roles &&
        Array.isArray(this.selectedUser.roles) &&
        this.selectedUser.roles.length > 0 &&
        this.selectedUser.roles.find(item => item.name === 'promotor')) return false
      return roles.includes(55)
    },
    checkCustomComponent () {
      if (this.customComponent) {
        this.changeCurrentComponent(this.customComponent)
      }
    },
    async getUser () {
      try {
        await this.$store.dispatch('getUser', { userId: this.userId })
      } catch (e) {
        this.loadingUser = false
      }
    },
    toggleMinimizedHeader (value) {
      this.minimizedHeader = value
    },
    toggleModal () {
      this.$emit('input', false)
    },
    toggleSideMenu () {
      this.minimizedSideMenu = !this.minimizedSideMenu
    },
    openPromotorDialog () {
      this.$store.commit('SET_METHOD_CREATE_OR_UPDATE_PROMOTOR', 'new')
      this.$store.commit('SET_NEW_EDIT_PROMOTOR_OBJ', {
        name: this.selectedUser.name,
        email: this.selectedUser.email,
        userId: this.selectedUser.userId
      })
      this.toggleModal()
      this.$router.push({ name: 'Promotors', params: { appid: this.$store.getters.appUuid } })
      this.$store.commit('SET_SHOW_NEW_EDIT_PROMOTOR_DIALOG', true)
    },
    async updatePerson (data) {
      const { key, value, secondKey } = data
      if (!key) return notifications.error(this.$t('general.youMustAddKeyToUpdateUser'))
      try {
        const selectedUser = { ...this.selectedUser }
        if (secondKey) {
          await this.updateUserExtradata(data)
        } else {
          if (key === 'phone') {
            selectedUser.phone = value.phone
            selectedUser.country = value.code
            selectedUser.countryCode = value.number
          } else {
            selectedUser[key] = value
          }
          this.$store.commit('SET_SELECTED_USER', selectedUser)
          await this.$store.dispatch('updateUser',
            {
              userId: selectedUser.userId,
              ...selectedUser
            }
          )
          if (key === 'rolId') {
            const wasPromotorAssigned = this.checkIfPromotorRolWasAssigned(value)
            if (wasPromotorAssigned) {
              this.openPromotorDialog()
              return
            }
          }
          await this.getUser()
        }
      } catch (e) {
        notifications.error(e.message)
        throw e
      }
    },
    async updateUserExtradata (event) {
      try {
        const data = {
          userId: this.selectedUser.userId,
          extradata: [{
            field: event.secondKey,
            value: event.value
          }]
        }

        const response = await this.$store.dispatch('updateUserExtradata', data)
        this.$store.commit('SET_SELECTED_USER', response.user)
      } catch (e) {
        console.error(e)
        this.loading = false
      }
    }
  },
  props: {
    auths: {
      default: () => [],
      type: Array
    },
    customComponent: {
      default: '',
      type: String
    },
    mainColor: {
      default: 'kbPink',
      type: String
    },
    value: {
      default: false,
      type: Boolean
    },
    userId: {
      type: String,
      default: ''
    }
  },
  watch: {
    async value (value) {
      if (!value) {
        this.clearSelectedUser()
      } else {
        this.checkCustomComponent()
        this.loadingUser = true
        await this.getUser()
        this.loadingUser = false
      }
    }
  }
}
</script>

<style scoped>
  ::v-deep.v-dialog {
    border-radius: 10px!important;
    overflow: hidden!important;
  }
  .view-user-card {
    background-color: white;
    border-radius: 10px;
    height: 90vh;
    overflow: hidden!important;
  }
  .view-user-card .component-container {
    overflow: hidden auto;
    height: 47vh;
  }
  .view-user-card .component-container.full-height {
    height: 61vh;
  }
  ::v-deep.view-user-card .component-container::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3)!important;
    background-color: #F5F5F5!important;
  }

  ::v-deep.view-user-card .component-container::-webkit-scrollbar {
    width: 4px;
    background-color: #F5F5F5!important;
  }

  ::v-deep.view-user-card .component-container::-webkit-scrollbar-thumb {
    background-color: #737373!important;
  }

  ::v-deep.view-user-card.dark .component-container::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3)!important;
    background-color: #737373!important;
  }

  ::v-deep.view-user-card.dark .component-container::-webkit-scrollbar {
    width: 4px;
    background-color: #737373!important;
  }

  ::v-deep.view-user-card.dark .component-container::-webkit-scrollbar-thumb {
    background-color: #F5F5F5!important;
  }
  @media only screen and (min-width: 1600px) {
    .view-user-card .component-container {
      height: 50vh;
    }
    .view-user-card .component-container.full-height {
      height: 67vh;
    }
  }
</style>
